<template>
    <div v-if="isModalOpen" class="modal" @click="clickOutside">
        <div class="modal-content">
            <h2>{{ getTranslatedText(title) }}</h2>
            <p>{{ getTranslatedText(description) }}</p>
            <div class="modal-actions">
                <button class="modal-actions-button-cancel" @click="cancel">Cancel</button>
                <button class="modal-actions-button-confirm" @click="confirm">Confirm</button>
            </div>
        </div>
    </div>
</template>

<script>
import languageMixins from '@/mixins/language/language-mixins'
import themeMixins from '@/mixins/pathAssets/path-assets-mixins'
import EventBus from '@/utils/EventBus'
import { isStrEmpty } from '@/utils/utils'

export default {
    mixins: [languageMixins, themeMixins],
    props: {
        listNumber: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isModalOpen: false,
            title: '',
            description: '',
        }
    },
    created() {
        EventBus.$on('on-show-confirm', (param) => this.open(param))
    },

    destroyed() {
        EventBus.$off('on-show-confirm')
    },

    methods: {
        open(param) {
            this.title = param?.title && !isStrEmpty(param.title) ? param.title : 'Confirmation'
            this.description = param?.description && !isStrEmpty(param.description) ? param.description : 'are you sure you want to delete?'
            this.isModalOpen = true
        },
        cancel() {
            this.isModalOpen = false
        },
        confirm() {
            this.isModalOpen = false
            EventBus.$emit('on-confirm')
        },
        clickOutside(event) {
            if (event.target.classList.contains('modal')) {
                this.cancel()
            }
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/common/confirm/index.scss';
</style>
